/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Ai_Integration_Tlm_3Inputs */

const en_svc_ai_integration_tlm_3 = /** @type {(inputs: Svc_Ai_Integration_Tlm_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`validation`)
};

const ar_svc_ai_integration_tlm_3 = /** @type {(inputs: Svc_Ai_Integration_Tlm_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`التحقق`)
};

const bn_svc_ai_integration_tlm_3 = /** @type {(inputs: Svc_Ai_Integration_Tlm_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`validation`)
};

const de_svc_ai_integration_tlm_3 = /** @type {(inputs: Svc_Ai_Integration_Tlm_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Validierung`)
};

const es_svc_ai_integration_tlm_3 = /** @type {(inputs: Svc_Ai_Integration_Tlm_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`validación`)
};

const fr_svc_ai_integration_tlm_3 = /** @type {(inputs: Svc_Ai_Integration_Tlm_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Validation`)
};

const pt_svc_ai_integration_tlm_3 = /** @type {(inputs: Svc_Ai_Integration_Tlm_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`validação`)
};

const zh_svc_ai_integration_tlm_3 = /** @type {(inputs: Svc_Ai_Integration_Tlm_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`验证`)
};

const tr_svc_ai_integration_tlm_3 = /** @type {(inputs: Svc_Ai_Integration_Tlm_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`doğrulama`)
};

const ru_svc_ai_integration_tlm_3 = /** @type {(inputs: Svc_Ai_Integration_Tlm_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`проверка`)
};

const pl_svc_ai_integration_tlm_3 = /** @type {(inputs: Svc_Ai_Integration_Tlm_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Walidacja`)
};

/**
* | output |
* | --- |
* | "validation" |
*
* @param {Svc_Ai_Integration_Tlm_3Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_ai_integration_tlm_3 = /** @type {((inputs?: Svc_Ai_Integration_Tlm_3Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Ai_Integration_Tlm_3Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_ai_integration_tlm_3(inputs)
	if (locale === "bn") return bn_svc_ai_integration_tlm_3(inputs)
	if (locale === "de") return de_svc_ai_integration_tlm_3(inputs)
	if (locale === "es") return es_svc_ai_integration_tlm_3(inputs)
	if (locale === "fr") return fr_svc_ai_integration_tlm_3(inputs)
	if (locale === "pt") return pt_svc_ai_integration_tlm_3(inputs)
	if (locale === "zh") return zh_svc_ai_integration_tlm_3(inputs)
	if (locale === "tr") return tr_svc_ai_integration_tlm_3(inputs)
	if (locale === "ru") return ru_svc_ai_integration_tlm_3(inputs)
	if (locale === "pl") return pl_svc_ai_integration_tlm_3(inputs)
	return en_svc_ai_integration_tlm_3(inputs)
});
export { svc_ai_integration_tlm_3 as "svc_ai-integration_tlm_3" }